

export default {
    state: {
        user: null,
        token: null
    },

    setToken: function (token) {
        this.state.token = token
        localStorage.state = JSON.stringify(this.state)
    },
    setUser: function (user) {
        this.state.user = user
        localStorage.state = JSON.stringify(this.state)
    },

    getUser: function() {
        return this.state.user;
    },

    clear() {
        this.state.user = null;
        this.state.token = null;
        localStorage.removeItem('state');
    }
}
